module.exports = __webpack_public_path__ + "assets/img/enterLogo.91dd59a2.png";